'use strict';
const angular = require('angular');

export class MapSidebarComponent {
  menu = [{
    title: 'Home',
    url: 'main'
  }];

  isCollapsed = true;

  constructor($state, $scope, $rootScope, fetch) {
    'ngInject';

    this.$state = $state;
    this.$scope = $scope;
    this.fetch = fetch;
    $scope.showEditTools = true;

    /**
     * Updates the information in Map Side Bar on clicking an individual parcel
     * @param {*} data - passed via the click event to the function
     */
    $scope.updateInfoBox = function(data){
      $scope.feature = data;
      $scope.$apply();
    };
    
    // Watch for changes in selectedRecordDetails to toggle sidebar visibility
    $scope.$watch('selectedRecordDetails.length', function(newVal) {
      if (newVal > 0) {
        // If there are selected records, show the sidebar
        angular.element('#sidebar').addClass('show');
      }
    });
    
    // Add event listeners for sidebar collapse/show events
    angular.element(document).ready(function() {
      // Check the initial state check
      if (angular.element('#sidebar').hasClass('show')) {
        angular.element('.map-tools__toggle').hide();
      } else {
        angular.element('.map-tools__toggle').show();
      }
    });
  }

  $onInit(){
    // Watch for changes in selectedRecordDetails to toggle sidebar visibility
    this.$scope.$watch('selectedRecordDetails.length', (newVal) => {
      if (newVal > 0) {
        // If there are selected records, show the sidebar
        $('#sidebar').addClass('show');
        // Hide the edit button when sidebar is shown
        $('.map-tools__toggle').hide();
      }
    });
    
    // Add event listeners for sidebar collapse/show to manage button visibility
    $('#sidebar').on('hidden.bs.collapse', () => {
      $('.map-tools__toggle').show();
    });
    
    $('#sidebar').on('shown.bs.collapse', () => {
      $('.map-tools__toggle').hide();
    });
  }


}


export default angular.module('appApp.mapsidebar', [])
  .directive('mapsidebar', function() {
    return {
      template: require('./mapsidebar.html'),
      restrict: 'EA',
      controller: MapSidebarComponent,
      controllerAs:'mapSidebarCtrl',
      link: function(scope, element, attrs) {}
    };
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/directives/mapsidebar/mapsidebar.directive.js